@if (showQueryBuilder | async) {
  <div [ngClass]="{ 'pointer-events-none opacity-50': isDisabled() }">
    <ejs-querybuilder
      #querybuilder
      class="row"
      [rule]="importRules.value"
      (created)="onQueryBuilderCreated()"
      (ruleChange)="updateContent()"
      [columns]="columns.value"
      [separator]="separator"
      [fieldModel]="{ allowFiltering: true }"
    />
    @if (false) {
      <div class="preview">
        <div class="content">
          <ejs-radiobutton
            (change)="change($event)"
            label="Inline"
            name="state"
            value="Inline"
          />
          <ejs-radiobutton
            style="margin-left: 20px"
            label="Parameterized"
            (change)="change($event)"
            name="state"
            value="Parameterized"
          />
          <ejs-radiobutton
            style="margin-left: 20px"
            (change)="change($event)"
            checked="true"
            label="Named Parameter"
            name="state"
            value="NamedParameter"
          />
          <div id="content" style="margin-top: 10px">
            <textarea pInputTextarea readonly class="w-full h-4rem">{{
              content
            }}</textarea>
          </div>
        </div>
      </div>
    }
  </div>
}

<!-- Skeleton -->
@if ((showQueryBuilder | async) === false) {
  <div>
    <div class="flex align-items-center mb-2">
      <p-skeleton width="6rem" height="1.35rem" />
      <p-skeleton width="6rem" height="1.35rem" styleClass="mx-2" />
      <p-skeleton width="2rem" height="2rem" shape="circle" />
    </div>
    <div class="flex align-items-center mb-2">
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="2rem" height="2rem" shape="circle" />
    </div>
    <div class="flex align-items-center mb-2">
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="2rem" height="2rem" shape="circle" />
    </div>
    <div class="flex align-items-center mb-2">
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
      <p-skeleton width="2rem" height="2rem" shape="circle" />
    </div>
  </div>
}
<!-- Skeleton -->
